import ReactDOM from "react-dom/client";
import $ from "jquery";
import "react-bootstrap";
import App from "./App";
import { clearStaleClientCookie } from "./helpers/clientHelper";

// Making jQuery globally available
window.$ = window.jQuery = $;

// Direct visits (not from a client site) should not show a leftover client logo.
clearStaleClientCookie();

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(<App />);
